import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import * as Yup from 'yup';
import {
  Form as BaseForm,
  TextField,
  SelectFieldV2,
  CheckBoxField,
  CancelPopupButton,
  SubmitButton,
} from 'ui/FormElement';
import statuses from 'data/renewal_method_statuses';
import Modal from '../../../../ui/Modal';

import { useContext } from '../../Context';
import RenewalNotification from './Fields/RenewalNotification';

export default function EditModal({ row, onHide }) {
  const { dispatch, actions, state } = useContext();

  const FormSchema = Yup.object().shape({
    renewal_method: Yup.string().required('required'),
  });

  const [loader, setLoader] = useState(false);

  const formData = row && row.attributes;

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.updatePlan(
      dispatch,
      state.enterpriseId,
      row.attributes.id,
      values,
      () => {
        setLoader(false);
        toastr.info('Plan updated.');
        onHide();
        actions.load(dispatch, state.enterpriseId);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <Modal
      show={row != null}
      onHide={onHide}
      header="Renewal And Notification Settings"
    >
      <BaseForm
        enableReinitialize
        validationSchema={FormSchema}
        initialValues={formData}
        onSubmit={onSubmit}
      >
        <div>
          <SelectFieldV2
            name="renewal_method"
            placeholder="Choose Renewal Method"
            isMulti={false}
            options={statuses}
            label={(
              <>
                <span>Renewal Method</span>
                <abbr title="required">*</abbr>
              </>
              )}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 99999 }),
            }}
            menuPortalTarget={document.body}
            isDisabled={row && row.attributes.status != 'active'}
          />
          <TextField
            name="renewal_date_form"
            label={(
              <span>Renewal Date</span>
              )}
            disabled
          />
          <h3>Notifications</h3>
          <p>
            Renewal Notifications will be sent 60 days before the renewal
            date.
          </p>

          <Row className="mt20">
            <Col md={4}>
              <label>Notifications</label>
            </Col>
            <Col md={4}>
              <Row>
                <Col md={4}>Off</Col>
                <Col className="text-center" md={4}>
                  {row && <RenewalNotification />}
                </Col>
                <Col className="text-right" md={4}>
                  On
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div>
          <p>
            Click the link below to view the notification depending on the
            Renewal Method:
          </p>
          <p>
            <a
              target="_blank"
              href={`/mail_preview/renewal?id=${row && row.id}`}
              rel="noreferrer"
            >
              Automatic Renewal Notification
            </a>
          </p>
          <p>
            <a
              target="_blank"
              href={`/mail_preview/adjusted?id=${row && row.id}`}
              rel="noreferrer"
            >
              Adjusted Renewal Notification
            </a>
          </p>
          <p>
            <a
              target="_blank"
              href={`/mail_preview/expiration?id=${row && row.id}`}
              rel="noreferrer"
            >
              Nonrecurring Renewal Notification
            </a>
          </p>
        </div>
        <div className="mt50 mb30">
          <Row>
            <Col md={6}>
              <CancelPopupButton
                className="btn btn-primary btn-outline mr5 ml5 width-120"
                title="Cancel"
                onClick={() => onHide()}
              />
            </Col>
            <Col md={6} className="text-right">
              <SubmitButton
                title={`${loader ? 'Updating ...' : 'Update'}`}
                className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                  loader ? 'not-possible-click' : ''
                }`}
              />
            </Col>
          </Row>
        </div>
      </BaseForm>
    </Modal>
  );
}
